import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { initializeAuth } from "../features/auth/authSlice";
import logger from "../utils/logger";

/**
 * Initializes authentication state on app load
 * Checks for stored tokens and restores user session
 * Non-blocking: Shows app immediately while auth loads in background
 */
export default function AuthInitializer({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    logger.debug("Initializing auth state...");

    // Initialize auth but don't block rendering
    dispatch(initializeAuth());
  }, [dispatch]);

  // Don't block - render immediately
  // The navbar will update when auth loads
  return children;
}
